module.exports = __webpack_public_path__ + "8869cce4d0c3b3897eeadea3fa3c8032.glb";